import { RootState } from 'redux/store'

export const selectedRangeSelector = (state: RootState) =>
  state.dashboardReducer.selectedDashboardRange
